import React, { useContext, useState } from "react";

import channels from "../../../types/channels";
import discord_channels from "../../../types/discord_channels";
import useChannels from "./useChannels";

type ChannelsContextProps = {
  loading: boolean;
  allChannels: channels[] | discord_channels[] | [];
  setChannels:
    | React.Dispatch<React.SetStateAction<channels[] | discord_channels[]>>
    | [];
  selectedChannel: channels | discord_channels | null;
  setSelectedChannel: React.Dispatch<
    React.SetStateAction<channels | discord_channels | null>
  > | null;
};

type SlackChannelsContextProps = {
  loading: boolean;
  allChannels: channels[] | [];
  setChannels: React.Dispatch<React.SetStateAction<channels[]>> | [];
  selectedChannel: channels | null;
  setSelectedChannel: React.Dispatch<
    React.SetStateAction<channels | null>
  > | null;
};

type DiscordChannelsContextProps = {
  loading: boolean;
  allChannels: discord_channels[] | [];
  setChannels: React.Dispatch<React.SetStateAction<discord_channels[]>> | [];
  selectedChannel: discord_channels | null;
  setSelectedChannel: React.Dispatch<
    React.SetStateAction<discord_channels | null>
  > | null;
};

const DiscordChannelsContext = React.createContext<DiscordChannelsContextProps>(
  {
    loading: true,
    allChannels: [],
    setChannels: [],
    selectedChannel: null,
    setSelectedChannel: null,
  }
);

const SlackChannelsContext = React.createContext<SlackChannelsContextProps>({
  loading: true,
  allChannels: [],
  setChannels: [],
  selectedChannel: null,
  setSelectedChannel: null,
});

// Custom hooks
export function useDiscordChannelsContext() {
  return useContext(DiscordChannelsContext);
}

export function useSlackChannelsContext() {
  return useContext(SlackChannelsContext);
}

// Providers
export function DiscordChannelsProvider({ children }: any) {
  const guildId: string = localStorage.getItem("guild-id") || "";
  const platform = "discord";
  const {
    isLoading: loading,
    allChannels,
    setChannels,
    selectedChannel,
    setSelectedChannel,
  } = useChannels(guildId, platform);

  return (
    <DiscordChannelsContext.Provider
      value={{
        loading,
        allChannels,
        setChannels,
        selectedChannel,
        setSelectedChannel,
      }}
    >
      {children}
    </DiscordChannelsContext.Provider>
  );
}

export function SlackChannelsProvider({ children }: any) {
  const teamId: string = localStorage.getItem("team-id") || "";
  const platform = "slack";

  const {
    isLoading: loading,
    allChannels,
    setChannels,
    selectedChannel,
    setSelectedChannel,
  } = useChannels(teamId, platform);

  return (
    <SlackChannelsContext.Provider
      value={{
        loading,
        allChannels,
        setChannels,
        selectedChannel,
        setSelectedChannel,
      }}
    >
      {children}
    </SlackChannelsContext.Provider>
  );
}
